/* istanbul ignore file */
import React from 'react';
import {
  MenuItemOption,
  MenuItemOptionProps,
  forwardRef,
} from '@chakra-ui/react';

export interface ActionListItemOptionProps extends MenuItemOptionProps {
  children: React.ReactNode;
  /**
   * Adds an additional description to the selection tile that is located
   * underneath the main selection tile label
   */
  description?: string;
}

/**
 * Adds additional functionality to the action list item component
 * by turning the item into either a radio or checkbox action list item. The
 * `ActionListItemOption` component must be used within the `ActionMenuOptionGroup`
 * component.
 *
 * @ignore CALLOUT - This should not be used by itself. This component is here so we can
 * ensure that the correct types are passed into the ActionMenuOptionGroup component.
 * Chakra will only allow a direct MenuItemOption component child of the
 * MenuOptionGroup component in order for it to work properly.
 */
export const ActionListItemOption = forwardRef<
  ActionListItemOptionProps,
  'button'
>((props, ref) => {
  return <MenuItemOption ref={ref} {...props}></MenuItemOption>;
});
